export const skillsData = [
  {
    label: "FRONT END",
    data: [
      {
        skillName: "HTML",
        percentage: "90",
      },
      {
        skillName: "CSS",
        percentage: "50",
      },
      {
        skillName: "JAVASCRIPT",
        percentage: "80",
      },
    ],
  },
  {
    label: "BACK END",
    data: [
      {
        skillName: "JAVA",
        percentage: "70",
      },
      {
        skillName: "PYTHON",
        percentage: "65",
      },
      {
        skillName: "KOTLIN",
        percentage: "35",
      },
    ],
  },
  {
    label: "DATABASES",
    data: [
      {
        skillName: "SQL",
        percentage: "70",
      },
      {
        skillName: "MONGO DB",
        percentage: "65",
      },
      {
        skillName: "ORACLE",
        percentage: "85",
      },
    ],
  },
];
